import { Roles } from 'app/slice/types';

export const allowedroles = [
  Roles.Administrators,
  Roles.InstrumentEventsAdmin,
  Roles.GroupAdministrators,
  Roles.LabTech,
];
